import React from 'react';
import {
    List,
    Datagrid,
    TextField,
} from 'react-admin';


const ProfesionalesList = (props) => (
  <List {...props} bulkActionButtons={false}>
        <Datagrid rowClick="show">
            <TextField source="id" />
            <TextField source="nombres" />
            <TextField source="apellidos" />
            <TextField source="matricula" />
       </Datagrid>
  </List>
);

export default ProfesionalesList;
